
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"21.731","height":"21.731"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 319","transform":"translate(-7016.404 -1758.397)","fill":"none","stroke":"#707070","stroke-linecap":"round","stroke-miterlimit":"10"}},[_c('rect',{attrs:{"data-name":"Rectangle 187","width":"13.488","height":"13.488","rx":"2.835","transform":"translate(7023.897 1765.89)","stroke-width":"1.5"}}),_c('rect',{attrs:{"data-name":"Rectangle 188","width":"13.488","height":"13.488","rx":"2.835","transform":"translate(7017.154 1759.147)","stroke-width":"1.5"}}),_c('path',{attrs:{"data-name":"Line 44","stroke-width":".5","d":"M7030.428 1769.351l-3.092 3.092"}}),_c('path',{attrs:{"data-name":"Line 45","stroke-width":".5","d":"M7030.13 1766.446l-5.698 5.698"}}),_c('path',{attrs:{"data-name":"Line 46","stroke-width":".5","d":"M7027.237 1766.159l-3.092 3.092"}})])])
          )
        }
      }
    